import React, { FC } from 'react';
import MuiChip from '@material-ui/core/Chip';

// INTERFACE
import { ChipProps } from './Chip.interface';

const Chip: FC<ChipProps> = ({ testId, ...props }) => <MuiChip data-testid={testId} {...props} />;

export default Chip;
